var TableCatPage = {
  pagination: null,
  list: []
};

TableCatPage.init = function () {};

TableCatPage.pageChanged = function (pageQuery) {
  const params = new URLSearchParams(pageQuery);
  const page = params.get('page');
  window.location.href = '/katalog/stoly-kategorie/' + page;
};
